import {ElementRef} from '@angular/core';
import {DynamicScript} from '../../classes/dynamicScripts';
import {Observable} from 'rxjs';

export abstract class DomManipulationService {

  /**
   * Load a script into the DOM head.
   * @param id Id of the script element
   * @param src Source of the script
   * @returns An observable that returns true when the script is loaded.
   */
  abstract loadScript(script: DynamicScript): Observable<boolean>;

  abstract loadScriptAsync(script: DynamicScript): Promise<boolean>;

  abstract removeElementById(scriptId: string);

  abstract focus(element: ElementRef);

  abstract blur(element: ElementRef)

  abstract querySelectorAndSetInnerHTML(elementRef: ElementRef, querySelector: string, text: string);

  abstract scrollIntoView(element: ElementRef, top: boolean);

  abstract scrollToTop(element?: ElementRef);

  abstract scrollTo(x: number, y: number);

  abstract querySelectorContent(querySelector: string, description: string);

  abstract querySelector(element: ElementRef, selector: string);

  abstract documentQuerySelectorHeight(selector: string): number;

  abstract runFunctionWithTimeout(func: any, timeout: number);
}
